<template>
  <div>
    <div id="searcher">
      <div class="wrapper">
        <div class="search-box">
          <!-- <el-input
            placeholder="请输入检索词"
            v-model="searchInput"
            class="search-input"
            @keyup.enter.native="handleSearch"
          >
            <el-button
              class="search-input_button"
              slot="append"
              @click="handleSearch"
              >检索</el-button
            >
          </el-input> -->
          <div class="search-text">
            <h2>轻便研究 区域导航</h2>
          </div>
          <el-autocomplete class="search-input"
                           v-model="regionSearch"
                           :fetch-suggestions="queryRegionSearch"
                           placeholder="请输入内容"
                           :trigger-on-focus="false"
                           @select="handleRegionSelect"
                           value-key="name"
                           value="id"
                           style="width: 100%">
            <el-button class="search-input_button"
                       slot="append"
                       @click="handleSearch">检索</el-button>
          </el-autocomplete>
        </div>
      </div>
    </div>
    <div id="body">
      <section>
        <div class="ibox">
          <div class="ibox_content">
            <div class="guid-tabs g-school">
              <div class="guid-tabs g-area">
                <div :class="
                    guidTabsMore
                      ? 'guid-tabs_content show-more'
                      : 'guid-tabs_content'
                  ">
                  <div class="guid-content">
                    <div class="guid-area-list">
                      <el-skeleton :loading="regionLoading"
                                   :count="16"
                                   animated>
                        <template slot="template">
                          <div class="list-item">
                            <div class="list-item_title">

                            </div>
                            <div class="list-item_content">
                              <div class="area-item">
                                <div class="area-item_title">
                                  <el-skeleton-item variant="h2"
                                                    style="width: 80px" />
                                </div>
                                <div class="area-item_content">
                                  <ul>
                                    <li v-for="item in 14"
                                        :key="item">
                                      <el-skeleton-item variant="text"
                                                        style="width:45px" />
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>

                          </div>
                        </template>
                        <template>

                          <div class="list-item"
                               v-for="item in regionList"
                               :key="item.letter">
                            <div class="list-item_title">
                              {{ item.letter }}
                            </div>
                            <div class="list-item_content">
                              <template v-for="province in item.provinceList">
                                <div class="area-item"
                                     :key="province.id"
                                     v-if="
                                province.cityList &&
                                province.cityList.length > 0
                              ">
                                  <div class="area-item_title"
                                       :id="'region' + province.id">
                                    <router-link :to="'/region/detail?id=' + province.id">
                                      {{ province.name }}
                                    </router-link>
                                  </div>
                                  <div class="area-item_content">
                                    <ul>
                                      <template v-if="
                                      municipality.indexOf(province.name) > -1
                                    ">
                                        <li>
                                          <router-link :to="'/region/detail?id=' + province.id">
                                            {{ province.name }}
                                          </router-link>
                                        </li>
                                      </template>
                                      <template v-else>
                                        <li v-for="city in province.cityList"
                                            :key="city.id"
                                            :id="'region' + city.id">
                                          <router-link :to="'/region/detail?id=' + city.id">
                                            {{ city.name }}
                                          </router-link>
                                        </li>
                                      </template>
                                    </ul>
                                  </div>
                                </div>
                              </template>
                            </div>
                          </div>
                        </template>
                      </el-skeleton>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { axiosOptions, axiosRequest } from "../../util/request";
import moment from "moment";
import { cutstr } from "../../util/utils";

export default {
  data () {
    return {
      guidTabsCompany: "",
      guidTabsMore: true,
      regionList: [],
      regionLoading: false,
      municipality: ["北京市", "重庆市", "上海市", "天津市"],
      regionSearch: "",
      regionSearchList: [],
      regionSearchItem: {},
    };
  },
  created () {
    this.regionLoading = true;
    axiosRequest("/region/index-list", {}, axiosOptions("get", "", "json"))
      .then((res) => {
        this.regionLoading = false;
        if (res.data && res.data.code === 200) {
          this.regionList = res.data.data;
          this.regionList.forEach((item) => {
            item.provinceList.forEach((province) => {
              this.regionSearchList.push({
                id: province.id,
                name: province.name,
              });
              if (this.municipality.indexOf(province.name) === -1) {
                province.cityList.forEach((city) => {
                  this.regionSearchList.push(city);
                });
              }
            });
          });
        }
      })
      .catch(() => {
        this.regionLoading = false;
      });
  },
  mounted () { },
  methods: {
    handleSearch () {
      const currentList = document.getElementsByClassName("region-current");
      if (currentList && currentList.length > 0) {
        currentList[0].className = "";
      }
      const element = document.getElementById(
        "region" + this.regionSearchItem.id
      );
      element.className = "region-current";
      element.scrollIntoView({ behavior: "smooth" });
    },
    queryRegionSearch (queryString, cb) {
      let results = this.regionSearchList.filter(
        (item) => item.name.indexOf(queryString) > -1
      );
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    handleRegionSelect (item) {
      this.regionSearchItem = item;
    },
    cutstring (str, len) {
      return cutstr(str, len);
    },
    dateFormat (cellValue) {
      if (!cellValue) return "";
      // return moment(cellValue).format("YYYY-MM-DD HH:mm:ss");
      return moment(cellValue).format("YYYY-MM-DD");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/var.scss";
@import "@/assets/css/web.scss";
@import "@/assets/css/search.scss";

.region-current {
  font-weight: bold;
}

.guid-tabs {
  &_content {
    max-height: inherit;
    min-height: inherit;
    padding: 40px 0;
    &:after {
      display: none;
    }
  }
}
.guid-content {
  max-height: inherit;
  min-height: inherit;
  .guid-class-list {
    width: 100%;
    height: auto;
    margin-left: 0;
    .guid-info {
      position: relative;
      left: 0;
      top: 0;
      float: left;
      width: 25%;
      height: 342px;
    }
    dl {
      float: left;
      width: calc(100% / 4);
    }
  }
}
</style>
